import './textarea.css';

/** Многострочное поле. Стили — в `textarea.css` на токенах `--theme-*`. */
const Textarea = ({ className = '', ...props }) => (
  <textarea className={`textarea ${className}`.trim()} {...props} />
);

export { Textarea };
